import React from "react";
import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";

interface PromptLevelCheckboxProps {
  code: string;
  label: string;
  checked: boolean;
  onToggle: (checked: boolean) => void;
}

/**
 * Checkbox + code pill (e.g. "FP — Full Physical") used in the prompt hierarchy grid.
 */
const PromptLevelCheckbox: React.FC<PromptLevelCheckboxProps> = ({
  code,
  label,
  checked,
  onToggle,
}) => (
  <FormControlLabel
    sx={{ mr: 0 }}
    control={
      <Checkbox
        size="small"
        checked={checked}
        onChange={(e) => onToggle(e.target.checked)}
        inputProps={{ "aria-label": `${code} ${label}` }}
      />
    }
    label={
      <Stack direction="row" gap={2} alignItems="center">
        <Typography
          component="span"
          variant="caption"
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "3px",
            px: 1,
            py: "1px",
            fontFamily: "monospace",
            minWidth: 28,
            textAlign: "center",
          }}
        >
          {code}
        </Typography>
        <Typography variant="body2">{label}</Typography>
      </Stack>
    }
  />
);

export default PromptLevelCheckbox;
